import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { DrawPrizeDto } from '~shared/schemas';
import { PrizeTypeImage } from '../prize-type-image';
import { MessageText } from '../message-text';

interface WinModalProps {
  prize: DrawPrizeDto;
  /** Текст канала «попап» из ответа розыгрыша; null — стандартная подсказка по категории приза. */
  popupMessage: string | null;
  onClose: () => void;
}

/** Модалка выигрыша (`#modal` макета) — после открытия карточки: текст попапа из админки, без него — стандартная
 *  подсказка по категории (add-prize-win-messages). Код промокода — только если его подставил текст попапа. */
export function WinModal({ prize, popupMessage, onClose }: WinModalProps) {
  const { t } = useTranslation('landing');

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const note =
    prize.category === 'PROMO'
      ? t('gifts.winModal.codeLaterHint')
      : prize.category === 'BONUS'
        ? t('gifts.winModal.bonusHint')
        : prize.category === 'BUSINESS'
          ? t('gifts.winModal.bizHint')
          : t('gifts.winModal.itemHint');

  return (
    <div className="modal show" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="mbox">
        <i className="rays" />
        <div className="em">
          <PrizeTypeImage prize={prize} className="ptype-lg" />
        </div>
        <div className="k">{t('gifts.winModal.kicker')}</div>
        <h3>{prize.name}</h3>
        {popupMessage ? <MessageText text={popupMessage} className="mnote mmsg" /> : <p className="mnote">{note}</p>}
        <button type="button" className="btn" onClick={onClose}>
          {t('gifts.winModal.closeBtn')}
        </button>
      </div>
    </div>
  );
}
